import { CareerMain } from "@/components/career";
import { MetaHead } from "@/components/shared/metaHead";
import { SchemaHead } from "@/components/shared/schemaHead";
import { IMetaHead, IPageMenu } from "@/interfaces";
import { ICareer } from "@/interfaces/ICareer";
import careerService from "@/lib/services/careerService";
import { GetServerSideProps, NextPage } from "next";

type Props = {
  data: ICareer,
  navSchemaData:IPageMenu[]
}

const Career: NextPage<Props> = ({ data,navSchemaData }: Props) => {
  const metaData: IMetaHead = {
    title: "Careers – Latest Job Opportunities at Interior Company",
    description: "Find current job opportunities at Interior Company and excel in your career. View our new job vacancies, apply for them and we will get back to you soon.",
    ogImage:`${process.env.SITE_URL}/assets/images/career-banner.png?w=1200&q=80`
  };

  return (
    <>
      <MetaHead metaData={metaData} />
      <SchemaHead navSchemaData={navSchemaData}/>
      <CareerMain data={data} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async () => {
  const jobList = await careerService.JobIdList();
  const departmentJobId = await careerService.GetDepartmentJobId();

  if (!departmentJobId || departmentJobId.length == 0 || !jobList || jobList.length == 0)
    return { notFound: true }
  return {
    props: {
      data: {
        jobList,
        departmentJobId
      }
    },
  };
};

export default Career;